package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents a single attempt at solving a digicode challenge.
 */
@Serializable
data class DigicodeAttempt(
    @SerialName("value")
    val value: String,

    @SerialName("is_success")
    val isSuccess: Boolean,

    @SerialName("attempted_at")
    val attemptedAt: Instant
)
